import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import * as recentRecordsActions from './recent-records.actions';
import { SystemEntity, UserAction } from '@wdx/shared/swagger-gen';
import {
    UseractionUseractionEntityEntitytypeRecordidApiService,
    UserMeRecentsApiService,
} from '@wdx/clmi/clmi-swagger-gen/api-services';
import { API_BYPASS_ERROR_HANDLER_HEADER_NAME } from '@wdx/shared/utils';

@Injectable()
export class RecentRecordsEffects {
    private actions$ = inject(Actions);
    private recentRecordsService = inject(UserMeRecentsApiService);
    private useractionApiService = inject(
        UseractionUseractionEntityEntitytypeRecordidApiService,
    );

    getUserRecentRecords$ = createEffect(() =>
        this.actions$.pipe(
            ofType(recentRecordsActions.getUserRecentRecords),
            switchMap(() =>
                this.recentRecordsService.get().pipe(
                    map((recentRecords) =>
                        recentRecordsActions.getUserRecentRecordsSuccess({
                            recentRecords,
                        }),
                    ),
                    catchError((error) =>
                        of(
                            recentRecordsActions.getUserRecentRecordsFailure({
                                error,
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    updateRecentlyViewedRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(recentRecordsActions.updateRecentlyViewedRecord),
            mergeMap((action) =>
                this.useractionApiService
                    .patch(
                        UserAction.View,
                        action.entityType,
                        action.recordId,
                        {},
                        undefined,
                        {
                            headers: {
                                [API_BYPASS_ERROR_HANDLER_HEADER_NAME]: 'true',
                            },
                        },
                    )
                    .pipe(
                        map((recentRecord) =>
                            recentRecordsActions.updateRecentlyViewedRecordSuccess(
                                { recentRecord },
                            ),
                        ),
                        catchError((error) =>
                            of(
                                recentRecordsActions.updateRecentlyViewedRecordFailure(
                                    { error },
                                ),
                            ),
                        ),
                    ),
            ),
        ),
    );
}
